var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.actionList, function(action, index) {
      return _c("action-item", {
        key: index,
        attrs: { "action-item": action, "context-item-id": _vm.contextItemId }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }